// Browser-owned content selection. Pure models/parsing live in the shared package.
import { GameContent, type TileCatalog, isLiquid as liquid } from '../../../shared/src/content';
export * from '../../../shared/src/content';

let current = new GameContent(new Map());
let version = 0;

/** The content in effect. */
export const content = (): GameContent => current;

/** The tile catalog in effect. */
export const tiles = (): TileCatalog => current.tiles;

/** Bumped each time other content is put in effect (screens re-read what they show). */
export const contentVersion = (): number => version;

export function useContent(c: GameContent): void {
  current = c;
  version++;
}

export const isLiquid = (g: number) => liquid(g, tiles());
